var map = {
	"./balazs.jpg": 7625,
	"./bogcsa.jpg": 3385,
	"./daniella.jpg": 2090,
	"./eszter.jpg": 5405,
	"./hero.jpg": 9374,
	"./istvan.jpg": 7645,
	"./janika.jpg": 9594,
	"./kristof.jpg": 3610,
	"./mark.jpg": 501,
	"./reka.jpeg": 3490,
	"./rita.jpg": 5220,
	"./roland.jpg": 5888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4057;